











































import { ValidationObserver } from 'vee-validate';
import { Component, Emit, Mixins, Prop, VModel } from 'vue-property-decorator';

import ModelSetter from "../../Mixins/ModelSetter";
import { targetPasswordsEqual, changePassword, PASSWORD_MIN_SYMBOLS } from "../../logic/auth/logic";
import { LocalChangePassword } from "../../logic/auth/types";
import { successNotificationWrapper } from "../../logic/helpers/NotificationService";
import PasswordInput from "../Pi/fields/PasswordInput/PasswordInput.vue";
import CapsLockIsActiveMessage from "./CapsLockIsActiveMessage.vue";
import NewPasswordFields from "./NewPasswordFields.vue";

@Component({
  data() {
    return {
      PASSWORD_MIN_SYMBOLS
    }
  },
  components: {
    NewPasswordFields,
    CapsLockIsActiveMessage,
    PasswordInput,
    ValidationObserver
  }
})
export default class SetUserPassword extends Mixins(ModelSetter) {
  @VModel({ type: Boolean }) isModalOpen!: boolean

  @Prop({ type: Boolean }) hasPassword!: boolean

  @Emit()
  passwordSet() {
    return null
  }

  passwordModel = this.defaultPasswordModel()

  afterModalClose() {
    this.passwordModel = this.defaultPasswordModel()
  }

  get arePasswordsEqualVm() {
    return targetPasswordsEqual(this.passwordModel.target, this.passwordModel.confirmTarget)
  }

  get modalTitle() {
    if (this.hasPassword) {
      return this.$t('password_modal_change_title').toString()
    }

    return this.$t('password_modal_set_title').toString()
  }

  defaultPasswordModel(): LocalChangePassword {
    return {
      current: null,
      target: '',
      confirmTarget: ''
    }
  }

  changePasswordVm() {
    changePassword(this.passwordModel, this.hasPassword)
      .then(res => {
        if (res) {
          successNotificationWrapper(this.$t('password_changed_success').toString(), '')
          this.isModalOpen = false
          this.passwordSet()
        }
      })
  }
}
